import { useQueryClient } from '@tanstack/react-query';
import useMutationApi from 'src/api/useMutationApi';
import { CompanyDTO } from './useCompany';

export interface CreateCompanyData {
  name: string;
  email?: string;
  modules?: string[]; // Array of module names to enable
}

export interface CreateCompanyResponse {
  company: CompanyDTO;
}

const useCreateCompany = () => {
  const queryClient = useQueryClient();

  return useMutationApi<CreateCompanyData, CreateCompanyResponse>({
    endpoint: 'core/companies',
    method: 'POST',
    successMessage: 'Company created successfully',
    errorMessage: 'Failed to create company',
    options: {
      onSuccess: () => {
        // Invalidate all paginated companies queries to refresh the list
        void queryClient.invalidateQueries({
          queryKey: ['companies', 'paginated'],
        });
      },
    },
  });
};

export default useCreateCompany;
